import { useState } from 'react';
import { Link } from 'react-router-dom';

export function Footer() {
  const [email, setEmail] = useState('');

  return (
    <footer className="border-t-4 border-t-transparent bg-navy-950" style={{ backgroundImage: 'linear-gradient(#181b22, #181b22), linear-gradient(to right, #088B7E, #67B733)', backgroundOrigin: 'border-box', backgroundClip: 'padding-box, border-box' }}>
      <div className="mx-auto max-w-7xl px-6 py-12 grid grid-cols-1 md:grid-cols-4 gap-12">
        {/* Column 1: Logo & Description */}
        <div className="flex flex-col gap-6">
          <Link to="/" className="inline-block">
            <img src="/images/edg3_labs_logo_light.svg" alt="Edg3 Labs" className="h-10 w-auto" />
          </Link>
          <p className="text-sm text-gray-400 leading-relaxed">
            Architecting the future of creativity. Precision tools for the modern digital workspace.
          </p>
          <div className="flex gap-5">
            <a href="https://github.com/edg3labs" target="_blank" rel="noopener noreferrer" aria-label="GitHub" className="text-gray-400 hover:text-teal-400 transition-colors">
              <svg className="h-5 w-5" fill="currentColor" viewBox="0 0 24 24"><path d="M12 0c-6.626 0-12 5.373-12 12 0 5.302 3.438 9.8 8.207 11.387.599.111.793-.261.793-.577v-2.234c-3.338.726-4.033-1.416-4.033-1.416-.546-1.387-1.333-1.756-1.333-1.756-1.089-.745.083-.729.083-.729 1.205.084 1.839 1.237 1.839 1.237 1.07 1.834 2.807 1.304 3.492.997.107-.775.418-1.305.762-1.604-2.665-.305-5.467-1.334-5.467-5.931 0-1.311.469-2.381 1.236-3.221-.124-.303-.535-1.524.117-3.176 0 0 1.008-.322 3.301 1.23.957-.266 1.983-.399 3.003-.404 1.02.005 2.047.138 3.006.404 2.291-1.552 3.297-1.23 3.297-1.23.653 1.653.242 2.874.118 3.176.77.84 1.235 1.911 1.235 3.221 0 4.609-2.807 5.624-5.479 5.921.43.372.823 1.102.823 2.222v3.293c0 .319.192.694.801.576 4.765-1.589 8.199-6.086 8.199-11.386 0-6.627-5.373-12-12-12z" /></svg>
            </a>
            <a href="https://twitter.com/edg3labs" target="_blank" rel="noopener noreferrer" aria-label="Twitter" className="text-gray-400 hover:text-teal-400 transition-colors">
              <svg className="h-5 w-5" fill="currentColor" viewBox="0 0 24 24"><path d="M18.244 2.25h3.308l-7.227 8.26 8.502 11.24H16.17l-5.214-6.817L4.99 21.75H1.68l7.73-8.835L1.254 2.25H8.08l4.713 6.231zm-1.161 17.52h1.833L7.084 4.126H5.117z" /></svg>
            </a>
            <a href="https://discord.gg/edg3labs" target="_blank" rel="noopener noreferrer" aria-label="Discord" className="text-gray-400 hover:text-teal-400 transition-colors">
              <svg className="h-5 w-5" fill="currentColor" viewBox="0 0 24 24"><path d="M20.317 4.3698a19.7913 19.7913 0 00-4.8851-1.5152.0741.0741 0 00-.0785.0371c-.211.3753-.4447.8648-.6083 1.2495-1.8447-.2762-3.68-.2762-5.4868 0-.1636-.3933-.4058-.8742-.6177-1.2495a.077.077 0 00-.0785-.037 19.7363 19.7363 0 00-4.8852 1.515.0699.0699 0 00-.0321.0277C.5334 9.0458-.319 13.5799.0992 18.0578a.0824.0824 0 00.0312.0561c2.0528 1.5076 4.0413 2.4228 5.9929 3.0294a.0777.0777 0 00.0842-.0276c.4616-.6304.8731-1.2952 1.226-1.9942a.076.076 0 00-.0416-.1057c-.6528-.2476-1.2743-.5495-1.8722-.8923a.077.077 0 01-.0076-.1277c.1258-.0943.2517-.1923.3718-.2914a.0743.0743 0 01.0776-.0105c3.9278 1.7933 8.18 1.7933 12.0614 0a.0739.0739 0 01.0785.0095c.1202.099.246.1981.3728.2924a.077.077 0 01-.0066.1276 12.2986 12.2986 0 01-1.873.8914.0766.0766 0 00-.0407.1067c.3604.698.7719 1.3628 1.225 1.9932a.076.076 0 00.0842.0286c1.961-.6067 3.9495-1.5219 6.0023-3.0294a.077.077 0 00.0313-.0552c.5004-5.177-.8382-9.6739-3.5485-13.6604a.061.061 0 00-.0312-.0286z" /></svg>
            </a>
          </div>
        </div>

        {/* Column 2: Products */}
        <div className="flex flex-col gap-6">
          <h4 className="font-display text-lg font-bold text-white">Products</h4>
          <ul className="flex flex-col gap-3">
            <li><Link to="/category/music" className="text-sm text-gray-400 hover:text-teal-400 transition-colors">Music</Link></li>
            <li><Link to="/category/games" className="text-sm text-gray-400 hover:text-teal-400 transition-colors">Games</Link></li>
            <li><Link to="/category/other-tools" className="text-sm text-gray-400 hover:text-teal-400 transition-colors">Other Tools</Link></li>
            <li><Link to="/category/experiments" className="text-sm text-gray-400 hover:text-teal-400 transition-colors">Experiments</Link></li>
          </ul>
        </div>

        {/* Column 3: Company */}
        <div className="flex flex-col gap-6">
          <h4 className="font-display text-lg font-bold text-white">Company</h4>
          <ul className="flex flex-col gap-3">
            <li><a href="#" className="text-sm text-gray-400 hover:text-teal-400 transition-colors">About</a></li>
            <li><a href="#" className="text-sm text-gray-400 hover:text-teal-400 transition-colors">Blog</a></li>
            <li><a href="#" className="text-sm text-gray-400 hover:text-teal-400 transition-colors">Contact</a></li>
            <li><a href="#" className="text-sm text-gray-400 hover:text-teal-400 transition-colors">Careers</a></li>
          </ul>
        </div>

        {/* Column 4: Newsletter */}
        <div className="flex flex-col gap-6">
          <h4 className="font-display text-lg font-bold text-white">Newsletter</h4>
          <p className="text-sm text-gray-400">
            Get the latest updates on new tools and releases.
          </p>
          <form onSubmit={(e) => e.preventDefault()} className="flex flex-col gap-3">
            <input
              type="email"
              value={email}
              onChange={(e) => setEmail(e.target.value)}
              placeholder="Email address"
              className="bg-navy-900/50 border border-white/10 text-white text-sm px-4 py-3 rounded-lg outline-none transition-all placeholder:text-gray-500 focus:border-teal-500/50"
            />
            <button
              type="submit"
              className="bg-gradient-to-r from-teal-500 to-green-500 text-navy-950 font-bold py-3 px-6 rounded-lg text-sm tracking-tight hover:brightness-110 transition-all"
            >
              Subscribe
            </button>
          </form>
        </div>
      </div>

      {/* Copyright Bar */}
      <div className="mx-auto max-w-7xl px-6 py-8 border-t border-white/5 flex flex-col md:flex-row justify-between items-center gap-4">
        <p className="text-xs text-gray-500">
          &copy; {new Date().getFullYear()} Edg3 Labs. All rights reserved.
        </p>
        <div className="flex gap-8">
          <a href="#" className="text-xs text-gray-500 hover:text-teal-400 transition-colors">Privacy</a>
          <a href="#" className="text-xs text-gray-500 hover:text-teal-400 transition-colors">Terms</a>
        </div>
      </div>
    </footer>
  );
}
